export default 'auth'
